module.exports = __webpack_public_path__ + "static/img/article-detail-error.af714557.svg";